"use client";
import { useState, memo } from "react";
import Slider from "react-slick";
import { Skeleton, Modal, IconButton } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import AnimatedReveal from "@/Components/HOC/AnimatedReveal";

const NextArrow = ({ onClick }) => (
  <div
    className="slider_custom_next_arrow_shadow cursor-pointer w-[161px] h-[90px] lg:h-[363px] flex items-center justify-end top-0"
    onClick={onClick}
  >
    <div className="slider_custom_next_arrow">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M7.42467 17.225C7.26634 17.225 7.10801 17.1667 6.98301 17.0417C6.74134 16.8 6.74134 16.4 6.98301 16.1583L12.4163 10.725C12.8163 10.325 12.8163 9.67502 12.4163 9.27502L6.98301 3.84168C6.74134 3.60002 6.74134 3.20002 6.98301 2.95835C7.22467 2.71668 7.62467 2.71668 7.86634 2.95835L13.2997 8.39168C13.7247 8.81668 13.9663 9.39168 13.9663 10C13.9663 10.6083 13.733 11.1833 13.2997 11.6083L7.86634 17.0417C7.74134 17.1583 7.58301 17.225 7.42467 17.225Z"
          fill="#F9F9F9"
        />
      </svg>
    </div>
  </div>
);

const ArtistsPodcast = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openModal = (videoId) => {
    setSelectedVideo(videoId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedVideo(null);
    setModalOpen(false);
  };

  return (
    <div className="pt-11 overflow-hidden pb-5 pl-6 lg:pt-[122px] lg:pb-[115px] lg:pl-[75px]">
      <AnimatedReveal animation="flip-down" duration={0.6} delay={0.2}>
        <div className="pr-6 lg:pr-[62px]">
          <p className="text-center text-[30px] leading-[50px] lg:text-[60px] lg:leading-[50px] font-[700]">
            Video Podcast
          </p>
          <div className="flex justify-center mt-3 lg:mt-5">
            <img
              onClick={() =>
                window.open("https://youtube.com/@qoncertapp", "_blank")
              }
              src="/assets/youtube.png"
              className="rounded-md cursor-pointer w-[136px] lg:max-w-[155px]"
              alt="YouTube"
            />
          </div>
        </div>
      </AnimatedReveal>

      <AnimatedReveal animation="slide-up" duration={0.6} delay={0.4}>
        <div className="py-[34px] relative lg:pb-7 lg:mt-[120px]">
          <Slider
            key={data?.length}
            {...{
              dots: false,
              infinite: false,
              speed: 500,
              slidesToShow: 2.5,
              slidesToScroll: 1,
              nextArrow: <NextArrow />,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                  },
                },
              ],
            }}
            className="youtubeVideosSlider"
          >
            {loading
              ? Array.from({ length: 5 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rectangular"
                    width="100%"
                    height={294}
                    className="rounded-[20px]"
                  />
                ))
              : data.map((d, i) => (
                  <div key={i} className="relative pr-4 w-full">
                    <img
                      src={d.snippet.thumbnails.high.url}
                      className="w-full object-cover max-h-[183px] lg:max-h-[294px] rounded-[20px]"
                      alt={d.snippet.title}
                    />
                    <div
                      className="youtube-icon cursor-pointer absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                      onClick={() => openModal(d.id.videoId)}
                    >
                      <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.16699 32.0003C1.16699 55.1237 8.87699 62.8337 32.0003 62.8337C55.1237 62.8337 62.8337 55.1237 62.8337 32.0003C62.8337 8.87699 55.1237 1.16699 32.0003 1.16699C8.87699 1.16699 1.16699 8.87699 1.16699 32.0003Z"
                          fill="black"
                          fillOpacity="0.75"
                          stroke="white"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M43.387 31.5185C43.387 28.5052 28.107 18.8652 26.3737 20.5985C24.6437 22.3318 24.4737 40.5418 26.3737 42.4385C28.277 44.3418 43.387 34.5318 43.387 31.5185Z"
                          stroke="white"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                  </div>
                ))}
          </Slider>
        </div>
      </AnimatedReveal>

      <Modal open={modalOpen} onClose={closeModal}>
        <div className="flex justify-center items-center h-screen bg-black/50 bg-opacity-75">
          <div className="w-[90%] lg:w-[50%] relative p-4 bg-[#1f222a] rounded-lg">
            <IconButton
              className="absolute top-0 left-[90%] lg:left-[96%]"
              onClick={closeModal}
            >
              <IoMdClose className="text-white" />
            </IconButton>
            {selectedVideo && (
              <iframe
                className="w-full h-[350px] lg:h-[450px]"
                src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1`}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default memo(ArtistsPodcast);
